import React from 'react';
import { useLatchedApiErrorDiagnostics } from '~/hooks/useLatchedApiErrorDiagnostics';

// data-record keeps the code readable in PostHog session recordings, which mask all
// text by default.
const ErrorTrackingCode = () => {
  const errorCode = useLatchedApiErrorDiagnostics()?.errorId;

  if (!errorCode) {
    return null;
  }

  return <span data-record="true"> ({errorCode})</span>;
};

export default ErrorTrackingCode;
